import createBaseService from "@/api/base-service.ts";
import type { SiteDocumentation } from "../../types/site-documentation";

const siteDocumentationService = {
	...createBaseService<SiteDocumentation>("/site-documentations"),
};

export default siteDocumentationService;
